// The MIT License
//
// Copyright (c) 2019 Google, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

const CSS_CLASSES = {
  ROOT: 'mdc-card',
  OUTLINED: 'mdc-card--outlined',
  PRIMARY_ACTION: 'mdc-card__primary-action',
  MEDIA: 'mdc-card__media',
  MEDIA_SQUARE: 'mdc-card__media--square',
  MEDIA_16_9: 'mdc-card__media--16-9',
  MEDIA_CONTENT: 'mdc-card__media-content',
  ACTIONS: 'mdc-card__actions',
  ACTIONS_FULL_BLEED: 'mdc-card__actions--full-bleed',
  ACTION_BUTTONS: 'mdc-card__action-buttons',
  ACTION_ICONS: 'mdc-card__action-icons',
  ACTION: 'mdc-card__action',
  ACTION_BUTTON: 'mdc-card__action--button',
  ACTION_ICON: 'mdc-card__action--icon',
};

export {CSS_CLASSES};



// WEBPACK FOOTER //
// ./packages/card/constant.ts